import React, { useEffect, useMemo, useState } from 'react'
import TreeAPI from '../../apis/TreeAPI';
import produce from 'immer';

const useCourses = () => {
    const [courses, setCourses] = useState<{
        [key: string]: IDBRealtimeCourse | undefined;
    }>({});

    useEffect(() => {
        setCourses({});
        const unsubscribe = TreeAPI.subscribeToCourses(
            (course: IDBRealtimeCourse) => {
                setCourses(
                    produce(draft => {
                        draft[course.id] = course;
                    })
                );
            },
            (id: string) => {
                setCourses(
                    produce(draft => {
                        draft[id] = undefined;
                    })
                );
            }
        );

        return () => unsubscribe();
    }, []);

    const coursesArray = useMemo(() => {
        const keys = Object.keys(courses);
        const result: IDBRealtimeCourse[] = [];

        keys.forEach(key => {
            const course = courses[key];
            if(course !== undefined)
                result.push(course);
        });

        result.sort((a, b) => a.order - b.order);

        return result;
    }, [courses]);

    return { courses, coursesArray };
}

export { useCourses };